import { ChevronLeft, ChevronRight } from 'lucide-react'
import React, { useEffect, useState } from 'react'
import {
    Pagination,
    PaginationContent,
    PaginationEllipsis,
    PaginationItem,
    PaginationLink,
    PaginationNext,
    PaginationPrevious,
} from '@/Components/ui/pagination'
import Constent from '@/utils/constent'

const CreateBulkPagination = ({ pageCount, totalCount = 0, onPageChange }) => {
    const [page, setPage] = useState(1)
    const pageSize = Constent.PAGINATION_SIZE
    const totalPageCount = Math.ceil(totalCount / pageSize)

    useEffect(() => {
        onPageChange(page)
    }, [page])
    const renderPageNumbers = () => {
        const items = []
        const maxVisiblePages = 5

        if (totalPageCount <= maxVisiblePages) {
            for (let i = 1; i <= totalPageCount; i++) {
                items.push(
                    <PaginationItem key={i}>
                        <PaginationLink
                            to="#"
                            onClick={() => {
                                setPage(i)
                            }}
                            isActive={page === i}
                        >
                            {i}
                        </PaginationLink>
                    </PaginationItem>
                )
            }
        } else {
            items.push(
                <PaginationItem key={1}>
                    <PaginationLink
                        to={'#'}
                        onClick={() => {
                            setPage(1)
                        }}
                        isActive={page === 1}
                    >
                        1
                    </PaginationLink>
                </PaginationItem>
            )

            if (page > 3) {
                items.push(
                    <PaginationItem key="ellipsis-start" className="dsd">
                        <PaginationEllipsis />
                    </PaginationItem>
                )
            }

            const start = Math.max(2, page - 1)
            const end = Math.min(totalPageCount - 1, page + 1)

            for (let i = start; i <= end; i++) {
                items.push(
                    <PaginationItem key={i}>
                        <PaginationLink
                            to={'#'}
                            onClick={() => {
                                setPage(i)
                            }}
                            isActive={page === i}
                        >
                            {i}
                        </PaginationLink>
                    </PaginationItem>
                )
            }

            if (page < totalPageCount - 2) {
                items.push(
                    <PaginationItem
                        key="ellipsis-end"
                    >
                        <PaginationEllipsis />
                    </PaginationItem>
                )
            }

            items.push(
                <PaginationItem key={totalPageCount}>
                    <PaginationLink
                        to={'#'}
                        isActive={page === totalPageCount}
                        onClick={() => {
                            setPage(totalPageCount)
                        }}
                    >
                        {totalPageCount}
                    </PaginationLink>
                </PaginationItem>
            )
        }
        return items
    }


    return (
        <div className="flex flex-row justify-end items-end gap-3 w-full mb-3 mt-4">
            <Pagination className="justify-end">
                <PaginationContent className="max-sm:gap-0">
                    <PaginationItem>
                        <PaginationPrevious
                            to={'#'}
                            aria-disabled={page === 1}
                            tabIndex={page === 1 ? -1 : undefined}
                            className={page === 1 ? 'pointer-events-none opacity-50' : undefined}
                            onClick={() => {
                                if (page > 1) {
                                    setPage(page - 1)
                                }
                            }}
                        />
                    </PaginationItem>
                    {renderPageNumbers()}
                    <PaginationItem>
                        <PaginationNext
                            to={'#'}
                            aria-disabled={page === totalPageCount || Math.min(page + 1, totalPageCount) === 0}
                            tabIndex={page === totalPageCount ? -1 : undefined}
                            className={
                                page === totalPageCount || Math.min(page + 1, totalPageCount) === 0 ? 'pointer-events-none opacity-50' : undefined
                            }
                            onClick={() => {
                                if (page < totalPageCount) {
                                    setPage(page + 1)
                                }
                            }}
                        />
                    </PaginationItem>
                </PaginationContent>
            </Pagination>
        </div>
    )
}

export default CreateBulkPagination
